function menu() {
    
    const body = document.querySelector(".js-body"),
        menuToggle = [...document.querySelectorAll(".js-menu-button")],
        header = document.querySelector(".js-header-wrapper"),
        headerParentNavs = header.querySelectorAll('#menu-primary-nav > .menu-item-has-children'),
        menu = document.querySelector(".js-menu"),
        menuParentNavs = menu.querySelectorAll('#menu-primary-nav-1 > .menu-item-has-children'),
        stopScrollingClass = "stop-scrolling",
        isActiveClass = "is-active"
    ;

    let isActive = false;

    //open menu timeline
    const menuOpenTl = gsap.timeline({ paused:true });
    menuOpenTl.to(menu, 0.3, { autoAlpha: 1, ease: Power1.easeInOut } );

    //close menu timeline
    const menuCloseTl = gsap.timeline({ paused:true });
    menuCloseTl.to(menu, 0.3, { autoAlpha: 0, ease: Power1.easeInOut });

    //bind events
    menuToggle.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            isActive = !isActive;

            if (isActive) {
                body.classList.add(stopScrollingClass, isActiveClass);
                openMenuAnimations(menuOpenTl,menuCloseTl, btn);
            } else {
                closeMenuAnimations(menuOpenTl,menuCloseTl, btn);
                body.classList.remove(stopScrollingClass, isActiveClass);
            }
        });
    });

    // mobile nav items
    if(menuParentNavs) {
        menuParentNavs.forEach((item) => {
            const link = item.getElementsByTagName('a')[0];

            // Listen for click, prevent nav and open sub-menu
            link.addEventListener('click', (event) => { 

                event.preventDefault();

                if (link.parentNode.classList.contains('sub-menu-open')) {
                    //hide sub nav if already open
                    link.parentNode.classList.remove('sub-menu-open');

                } else {
                    // If any other parent navs are open, close em up
                    menuParentNavs.forEach((item) => {
                        if(item.classList.contains('sub-menu-open')) {
                            item.classList.remove('sub-menu-open');
                        }
                    });

                    item.classList.toggle('sub-menu-open');

                }
              
            });
        });
    }

    if(header) {
        // Handle header behaviour on scroll
        let lastScrollTop = 0;

        window.addEventListener('scroll', debounce(function(){
            let scrollTop = window.scrollY;

            // Scrolling up and greater than 150
            if((scrollTop < lastScrollTop) && (scrollTop > 150) ) {
                header.classList.remove('scroll-down');
                header.classList.remove('scroll-top');
                header.classList.add('scroll-up');
            }

            // Scrolling down, greater 150
            if((scrollTop > lastScrollTop) && (scrollTop > 150)) {
                header.classList.remove('scroll-up');
                header.classList.remove('scroll-top');
                header.classList.add('scroll-down');
            }
            
            // Scrolling up, less than 150
            if((scrollTop < lastScrollTop) && (scrollTop < 150)) {
                header.classList.remove('scroll-up');
                header.classList.remove('scroll-down');
                header.classList.add('scroll-top');
            }

            lastScrollTop = scrollTop;
        }));
    }

     // desktop nav items
    if(headerParentNavs) {
        headerParentNavs.forEach((item) => {
            // Get first link
            const link = item.getElementsByTagName('a')[0];
            const subMenu = item.querySelector('.sub-menu');

            // Listen for click, prevent nav and open sub-menu
            link.addEventListener('click', (event) => {

                event.preventDefault();

                if (link.parentNode.classList.contains('sub-menu-open')) {
                    //hide sub nav if already open
                    link.parentNode.classList.remove('sub-menu-open');
                } else {
                    // If any other parent navs are open, close em up
                    headerParentNavs.forEach((item) => {
                        if(item.classList.contains('sub-menu-open')) {
                            item.classList.remove('sub-menu-open');
                        }
                    }); 

                    item.classList.toggle('sub-menu-open');
                }

            });

            // Define hideMeu var for use in both listeners
            let hideMenu = null;

            // Remove open class after mouse leaves sub-menu el
            item.addEventListener('mouseleave', () => {
                hideMenu = setTimeout(function() {
                    item.classList.remove('sub-menu-open');
                }, 1000);
            }, false);

            // If mouse goes back over subMenu while hideMenu is counting, cancel it 
            item.addEventListener('mouseover', () => {
                if(hideMenu) {
                    clearTimeout(hideMenu);
                }
            }, false);
        });
    }
}

 //functions
function openMenuAnimations(menuOpenTl,menuCloseTl) {
    menuCloseTl.pause();
    menuOpenTl.restart();
}

function closeMenuAnimations(menuOpenTl,menuCloseTl) {
    menuOpenTl.pause();
    menuCloseTl.restart();
}

// function addIsActiveClass(header, isActiveClass) {
//     header.classList.add(isActiveClass);
// }

// function removeIsActiveClass(header, isActiveClass) {
//     header.classList.remove(isActiveClass);
// }

